import React, {useState} from "react";
import { compose } from "recompose";
import { Table, Modal, ModalHeader, ModalBody, Button, Alert } from "reactstrap";
import { withTable, EditDeleteButtonsModal, Page, } from "components/common";
import { Trans } from "react-i18next";
import { Link } from "react-router-dom";
import { allowanceNotes as importantNotes } from "pages/UserList/modelNames";
import Edit from "./Edit";
import BackButton from "./../BackButton";
import { NotificationManager } from "react-notifications";
import ImportModal from "components/ImportModal";
import { humanError } from "services/util";

export const List = ({
    TableContainer,
    payroll,
    client,
    t,
    url = "allowance_rules",
    model = "local",
    data,
    PayrollTableDataFetch,
    PayrollBulkDeleteButton,
    onDeleteItem,
    match,
    refreshData,
    props,
}) => {
  const [modal, setModal]  = useState(false); 
  const toggleModal = () => setModal(!modal);

  const [ listItem, setListItem ]  = useState([])
  const [id, setId] = useState("new")
  const [amountTypesOptions, setAmountTypesOptions] = useState([]);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false)
  const [settingsMessage, setSettingsMessage] = useState('');

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const handleUploadFile = async (selectedFile) => {

    const formData = new FormData();
    setIsLoading(true)
    formData.append('file', selectedFile)

    payroll.post(`${url}/bulk_import`, formData)
      .then(({ data }) => {
        setIsLoading(false)
        NotificationManager.success(t("File imported successfully"));
        setTimeout(() => {
          setIsModalOpen(false);
          refreshData()
        }, 800);
      })
      .catch((err) => {
        setIsLoading(false);
        const error_message = humanError(err, "Error while importing File", t)
        NotificationManager.error(error_message);
        refreshData()
      });
  }

  const updateList = async () => {
    setModal(false)
    const data = await payroll.get(url).get("data");
    setListItem(data)
  }


  React.useEffect(()=>{
    setListItem(data.results)
    void (async () => {
      const amountTypes = await client.get("amount_types").get("data");
      setAmountTypesOptions(amountTypes);
      
    })()
  },[data])
  
  return(
  <Page title="" className="inv-table">
    <BackButton/>
    <h4 style={{marginTop:"15px",marginBottom:"20px"}}><Trans>Allowances Rules</Trans></h4>
    <PayrollBulkDeleteButton className="d-none" />
    
    <Button onClick={(e)=>{toggleModal(); setId("new")}} color="success" className="bt float-left mb-4" type="add">
      <i className="fa fa-plus mr-2" aria-hidden="true"></i> 
      <Trans>Add New</Trans>
    </Button>

    <Button size="md" color="primary" onClick={openModal}>
      <Trans>Import</Trans><span className="mx-1" /><i className="fas fa-file-excel" />
    </Button>

    {!settingsMessage && <Alert color="warning" className="mt-4 text-center">
      <h6 className="my-0">
        <Trans>Please configure the required allowance accounts in</Trans>{" "}
        <Link to="/payroll-new/settings"><Trans>Account Settings</Trans></Link>{" "}
        <Trans>before using Allowance Rules.</Trans>
      </h6>
    </Alert>}

    <TableContainer>
      <Table>
      <thead>
          <tr>
            <th style={{padding:"1rem"}} className="text-nowrap">
              <Trans>Description</Trans>
            </th>
            <th sortBy="amount" className="text-nowrap">
              <Trans>Amount</Trans>
            </th>
            <th sortBy="amount_type" className="text-nowrap">
              <Trans>Amount Type</Trans>
            </th>
            <th>
              <Trans>Actions</Trans>
            </th>
          </tr>
        </thead>
        <tbody>
        {listItem.map((i) => (
            <tr key={i.id}>
              <td>{i.description}</td>
              <td>{i.amount}</td>
              <td>{i.amount_type_display}</td>
              <td className="text-end text-nowrap">
                <EditDeleteButtonsModal
                  url={match.url}
                  id={i.id}
                  onDelete={onDeleteItem}
                  onEdit={(e)=>{setId(`${i.id}`); toggleModal();}}
                  />
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </TableContainer>
    <PayrollTableDataFetch />
    <Modal isOpen={modal} toggle={toggleModal} {...props}>
      <ModalHeader toggle={toggleModal}><Trans>Create Allowance Rule</Trans></ModalHeader>
      <ModalBody>
      
        <Edit {...props} _payroll={payroll} updateList={updateList} id={id} amountTypesOptions={amountTypesOptions} t={t} client={client} setSettingsMessage={setSettingsMessage} />
          
      </ModalBody>
      
    </Modal>
    
    <ImportModal
      isOpen={isModalOpen}
      toggle={closeModal}
      title="AllowanceRules"
      importantNotes={importantNotes}
      handleUpload={handleUploadFile}
    />
  </Page>
)};
 
const enhance = compose(withTable({ limit: 99999, url: "allowance_rules" }));

export default enhance(List);
